module.exports = __webpack_public_path__ + "img/paihang.51b45ba6.png";